import DeleteItemModal from './DeleteItemModal.container'
export default DeleteItemModal
